import { basePath, apiVersion } from './config';

export async function getTurnApi(token, user, date) {
  const url = `${basePath}/${apiVersion}/turn/${user}&${date}`;

  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };
  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export async function addTurnApi({ token, data }) {
  const url = `${basePath}/${apiVersion}/turn`;

  const params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(data),
  };

  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}

export async function addTurnPortalApi({ data, tenantId }) {
  const url = `${basePath}/${apiVersion}/turn-portal?tenant=${tenantId}`;

  const params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };

  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}

export async function updateTurnApi({ token, turnId, dataTurn }) {
  const url = `${basePath}/${apiVersion}/turn/${turnId}`;

  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    body: JSON.stringify(dataTurn),
  };

  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}

export async function updateTurnPortalApi({ turnId, dataTurn, tenantId }) {
  const url = `${basePath}/${apiVersion}/turn-portal/${turnId}?tenant=${tenantId}`;

  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(dataTurn),
  };

  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}
export async function updateStatusTurnApi({
  shiftId,
  turnId,
  status,
  token,
  important,
}) {
  const url = `${basePath}/${apiVersion}/update-turn-status/${turnId}&${shiftId}?status=${status}&important=${important}`;

  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result_1 = await response.json();
    return result_1;
  } catch (err) {
    return err;
  }
}

export async function deleteTurnApi({ shiftId, turnId, token, patientId }) {
  const url = `${basePath}/${apiVersion}/delete-turn/${turnId}&${shiftId}?portal=portal&patientId=${patientId}`;

  const params = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };

  return await fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err;
    });
}
